<template>
  <div class="page-root">
    <NavBar
        class="page-navbar"
        :links="portalData.landing_links"
        navbarBgColor="white"
        logoImg="logo-labsystech.png"
        :bigLogo="true"
    />

    <div class="page-content">
      <div class="vacancySingle">
        <div class="container">
          <div class="vacancySingle__wrapper">
            <div class="vacancySingle__content">
              <div class="vacancySingle__breadcrumbs">
                <a href="/#vacancies">{{componentData.vacancies[lang]}}</a>
                <span><img :src="require('./../../assets/breadcrumbs-arrow.png')" alt=""></span>
                <span>{{vacancyData.title}}</span>
              </div>
              <div class="vacancySingle__header">
                <div class="vacancySingle__header-box">
                  <div class="vacancySingle__header-icon">
                    <img class="img" :src="vacancyData.image"  alt=""/>
                  </div>
                  <div class="vacancySingle__header-descr">
                    <div class="vacancySingle__header-title">
                      {{vacancyData.title}}
                    </div>
                    <div class="vacancySingle__header-text vacancySingle__subtitle">
                      <div class="vacancySingle__header-geo">
                        <img :src="require('./../../assets/icon-geo.png')" alt="">
                      </div>
                      <span>{{vacancyData.subtitle[lang]}}</span>
                    </div>
                  </div>
                </div>
                <div class="vacancySingle__header-buttons">
                  <button class="button">{{componentData.details[lang]}}</button>
                </div>
              </div>
              <div class="vacancySingle__tabs">
                <div class="vacancySingle__tabs-item">
                  <div class="vacancySingle__text">
                    <div v-for="section in vacancyData.sections">
                      <h2>{{ section.title[lang] }}:</h2>
                      <ul>
                        <li v-for="item in section.items">{{item[lang]}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="vacancySingle__tabs-item">
                  <h2 class="block-title">{{componentData.contact[lang]}}</h2>
                  <form id="contactForm" class="vacancySingle__form" @submit.prevent="sendEmail()">
                    <input type="email" class="input-style" id="email" placeholder="Email *" required>
                    <input type="text" class="input-style" id="name" :placeholder="componentData.form.name[lang] + ' *'" required>
                    <textarea class="input-style" id="message" :placeholder="componentData.form.description[lang]"></textarea>
                    <button class="button" type="submit">{{ componentData.form.submit[lang] }}</button>
                  </form>
                </div>
              </div>
            </div>
            <div class="vacancySingle__sidebar">
              <button class="vacancySingle__sidebar-apply button" @click="document.getElementById('contactForm').scrollIntoView({behavior: 'smooth'});">{{componentData.apply[lang]}}</button>
              <p class="vacancySingle__sidebar-word">{{componentData.or[lang]}}</p>
              <div class="vacancySingle__sidebar-box">
                <button class="button" target="_blank" onclick="window.open('https://hh.ru/employer/2634665', '_blank')">
                  <img :src="require('./../../assets/platforms/hhru.png')" alt="">
                  <span>{{componentData.applyHH[lang]}}</span>
                </button>
              </div>
              <button class="vacancySingle__sidebar-share button">Поделиться</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import portalData from './../../portal.json';
import NavBar from "../components/navbar";
import PageFooter from "../components/pagefooter";
import CompanyGames from "../components/companygames";
import VacanciesList from "../components/vacancieslist";
import WorkingInfo from "../components/workinginfo";
import FAQ from "../components/faq";
import { useHead } from '@vueuse/head';

export default {
  name: "Landing Page",
  components: {VacanciesList, PageFooter, NavBar, CompanyGames, WorkingInfo, FAQ },
  data() {
    return {
      portalData,
    };
  },
  beforeMount() {
    useHead(computed(() => this.head));
  },
  computed: {
    head() {
      return {
        title: 'Clever Apps Games',
        meta: [
          { name: 'description', content: this.portalData.description[this.lang] },
          { property: 'og:title', content: this.portalData.title[this.lang] },
          { property: 'og:site_name', content: 'Clever Apps Games' },
          { property: 'og:description', content: this.portalData.description[this.lang] },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: `https://cleverappssg.com/games/` },
          { property: 'og:image', content: require('./../../assets/logo.png') },
          { property: 'twitter:title', content: this.portalData.title[this.lang] },
          { property: 'twitter:description', content: this.portalData.description[this.lang] },
          { property: 'twitter:card', content: require('./../../assets/logo.png') }
        ],
        link: Object.keys(this.portalData.languages).map(lang => ({
          rel: lang === this.lang ? "canonical" : "alternate",
          hreflang: lang,
          href: `https://cleverappssg.com/games`
        }))
      };
    },
    lang() {
      return this.language;
    },
    vacancy() {
      return decodeURIComponent(this.$route.params.vacancy);
    },
    vacancyData() {
      const data = portalData.Vacancy[this.vacancy];
      data.image = require(`./../../assets/vacancies/icon-${data.type}.png`);
      data.title = this.vacancy;
      return data;
    },
    componentData() {
      return portalData.Vacancy;
    }
  },
  methods: {
    sendEmail() {
      var email = document.getElementById("email").value;
      var name = document.getElementById("name").value;
      var message = document.getElementById("message").value;
      var subject = encodeURIComponent(`Заявка на вакансию ${this.vacancy} от ${name}`);
      var body = encodeURIComponent(`Имя: ${name}\nEmail: ${email}\n\nСообщение:\n${message}`);
      var mailtoLink = "mailto:job@labsystech.ru?subject=" + subject + "&body=" + body;
      window.location.href = mailtoLink;
    }
  }
};
</script>

<style>
:root {
  --text-color: #424243;
  --brand-blue: #16a6ff;
}
.page-title, .block-title {
  font-size: 35px;
  color: var(--brand-blue);
  font-weight: 700;
  font-family: 'Marvin', sans-serif;
  text-align: center;
}
</style>

<style scoped>
.vacancySingle {
  padding: 30px 0;
}
.vacancySingle__breadcrumbs {
  display: flex;
  align-items: center;
  color: #8f8f92;
  font-weight: bold;
}
.vacancySingle__breadcrumbs img {
  width: 16px;
  margin: 0 10px;
}
.vacancySingle__breadcrumbs a {
  text-decoration: none;
  color: #8f8f92;
}
.vacancySingle__breadcrumbs a:hover{
  text-decoration: underline;
}
.vacancySingle__breadcrumbs > * {
  font-size: 12px;
}
.vacancySingle__header-geo {
  width: 16px;
  min-width: 16px;
  margin-right: 10px;
}
.vacancySingle__header-geo img {
  width: 100%;
}
.vacancySingle__wrapper {
  max-width: 1480px;
  margin-left: auto;
  display: flex;
  align-items: flex-start;
  gap: 44px;
  padding-left: 110px;
}
.vacancySingle__content {
  width: calc(100% - 360px - 44px);
}
.vacancySingle__header-icon {
  border-radius: 16px;
  width: 60px;
}
.vacancySingle__header-icon img{
  width: 100%;
}
.vacancySingle__header-box {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 25px;
  margin-bottom: 25px;
}
.vacancySingle__subtitle {
  font-size: 16px;
  margin-top: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.vacancySingle__header-title {
  font-size: 26px;
  font-weight: bolder;
  font-family: 'Marvin', sans-serif;;
  color: var(--brand-blue);
}
.vacancySingle__subtitle img {
  width: 16px;
  margin-right: 10px;
}
.vacancySingle__subtitle span {
  margin-top: 2px;
}


.vacancySingle__header-buttons:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: #a0a0a1;
}
.button {
  padding: 4px 18px;
  border-radius: 30px;
  font-size: 22px;
  font-family: 'Marvin',serif;
  border-color: transparent;
  transition: .3s;
  font-weight: bolder;
  background: var(--brand-blue);
  color: #fff;
}
.button:hover {
  cursor: pointer;
}
.vacancySingle__header-buttons {
  margin-top: 34px;
  display: flex;
  gap: 37px;
  padding-bottom: 30px;
  position: relative;
}

.vacancySingle__header-buttons button {
   pointer-events: none;
}
.vacancySingle__text {
  font-size: 18px;
}
.vacancySingle__text h2 {
  margin: 32px 0 20px;
  font-family: 'Marvin', sans-serif;
  color: black;
  font-weight: bolder;
}
.siteFaqItem__answer ul,
.vacancySingle__text ul {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #787878;
  font-weight: bold;
  padding-left: 1em;
}
.siteFaqItem__answer li,
.vacancySingle__text li {
  position: relative;
  display: list-item;
  list-style-type: disc;
}
.vacancySingle__sidebar {
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 130px;
}
.vacancySingle__sidebar-word {
  font-size: 25px;
  text-align: center;
  margin: 18px 0;
  text-transform: capitalize;
  font-weight: bold;
}
.vacancySingle__sidebar-box {
  width: 100%;
  border-radius: 30px;
  border: 2px solid #a0a0a1;
  padding: 45px 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.vacancySingle__sidebar-box button {
  width: 100%;
  padding: 10px 10px 10px 19px;
  border-radius: 30px;
  background: var(--brand-blue);
  font-family: 'Marvin', sans-serif;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 18px;
  transition: .3s;
}
.button:hover {
  opacity: .7;
}
.vacancySingle__sidebar-box button img {
  width: 21px;
  border-radius: 3px;
}
.vacancySingle__sidebar-share {
  margin-top: 30px;
  padding: 10px 60px;
}
.media-wrapper {
  display: block;
  position: relative;
}
.vacancySingle__tabs {
  margin-top: 32px;
}
.vacancySingle__tabs-item:nth-child(2) {
  margin-top: 30px;
}
.vacancySingle__tabs-item:nth-child(2) .block-title {
  text-align: center;
}
.vacancySingle__form {
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.vacancySingle__form .button {
  max-width: 240px;
  width: 100%;
}
.input-style {
  border-radius: 18px;
  border: 2px solid #a0a0a1;
  font-size: 18px;
  padding: 10px 20px;
  font-weight: bold;
  width: 100%;
}
textarea.input-style {
  min-height: 200px;
  padding-top: 15px;
}
.shareLink {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  display: none;
}
.shareLink.active {
  display: flex;
}
.shareLink__wrapper {
  max-width: 380px;
  width: 100%;
  border-radius: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, .2);
  background: #fff;
  padding: 22px 35px 26px;
  position: relative;
  margin: auto;
  font-size: 18px;
}
.shareLink__socials {
  display: flex;
}
.shareLink__close {
  width: 20px;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.shareLink__close img {
  width: 100%;
}
.shareLink__title {
  text-align: center;
  font-weight: 600;
  margin-bottom: -10px;
}
.shareLink__subtitle {
  opacity: .7;
  font-weight: 600;
  margin: 16px 0 8px;
}
.shareLink__copyLink-label {
  height: 50px;
  border-radius: 100px;
  border: 2px solid #cfcfcf;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
}
.vacancySingle__header-text {
  display: flex;
  flex-direction: row;
}
.shareLink__copyLink-label p {
  width: calc(100% - 16px - 16px);
  text-overflow: ellipsis;
  overflow: hidden;
}
.shareLink__copyLink-label img {
  width: 16px;
}
.shareLink__socials {
  display: flex;
  justify-content: space-between;
}
.shareLink__socials img {
  width: 32px;
}
.shareLink__socials a {
  transition: .3s;
  cursor: pointer;
}
body.do-css-hover .shareLink__socials a:hover,
.shareLink__socials a:active {
  opacity: .7;
}
.shareLink__copyLink-icon .check-mark {
  display: none;
}
.shareLink__copyLink-icon .default {
  display: block;
}
.shareLink__copyLink-icon.active .check-mark {
  display: block;
}
.shareLink__copyLink-icon.active .default {
  display: none;
}

@media (max-width: 1000px) {
  .vacancySingle__wrapper {
    flex-direction: column;
  }
  .vacancySingle__content {
    width: 100%;
    padding-right: 25px;
    padding-left: 25px;
  }
  .vacancySingle__wrapper {
    padding: 0;
  }
  .vacancySingle__sidebar{
    margin: auto;
  }
}
</style>
